import { inject, Injectable } from '@angular/core';
import { Actions, ofActionDispatched } from '@ngxs/store';
import { filter, take } from 'rxjs';

import { SetUserInfoAction } from '@efficiently/client-domain-core';
import { SnackbarService } from '@efficiently/client-widget-snackbar';

@Injectable({
	providedIn: 'root',
})
export class HeaderService {
	private readonly snackbarService = inject(SnackbarService);
	private readonly actions$ = inject(Actions);

	public profileUpdatesMessage(): void {
		this.actions$
			.pipe(
				ofActionDispatched(SetUserInfoAction),
				take(1),
				filter(data => !!data),
			)
			.subscribe(() => {
				this.snackbarService.success('Profile Details saved', {
					verticalPosition: 'bottom',
					duration: 5000,
				});
			});
	}
}
